import {format, roundToNearestMinutes, formatDistance, intervalToDuration} from 'date-fns'
import { nl, enGB, fr } from 'date-fns/locale'

export class DateUtil{

    static readonly MYSQL_DATE_TIME_FORMAT = 'yyyy-MM-dd HH:mm:ss'
    static readonly MYSQL_DATE_FORMAT = 'yyyy-MM-dd'
    static readonly READABLE_DATE_FORMAT = 'EEEE d MMM yyyy'
    static readonly READABLE_DATE_TIME_FORMAT = 'EEEE d MMM yyyy HH:mm'
    static readonly READABLE_TIME_FORMAT = 'HH:mm'

    static getNowMysql = (useTime: boolean = true, round: number = 1) => {
        return format(roundToNearestMinutes(new Date(), { nearestTo: round }), useTime ? DateUtil.MYSQL_DATE_TIME_FORMAT : DateUtil.MYSQL_DATE_FORMAT)
    }

    static mysqlFromDate = (date, useTime: boolean = false) => {
        return format(date, useTime ? DateUtil.MYSQL_DATE_TIME_FORMAT : DateUtil.MYSQL_DATE_FORMAT)
    }

    static dateFromMysql = (mysql) => {
        return new Date(mysql.replace(/-/g, '/'))
    }

    static getReadableDateString = (mysqlString, showTime: boolean = false, locale: string = 'nl') => {
        if (locale === 'en') locale = 'enGB'
        const locales = {nl: nl, fr: fr, en: enGB}
        const d = DateUtil.dateFromMysql(mysqlString)
        return format(d, showTime ? DateUtil.READABLE_DATE_TIME_FORMAT : DateUtil.READABLE_DATE_FORMAT, {locale: locales[locale]})
    }

    static getReadableTimeString = (mysqlString) => {
        const d = DateUtil.dateFromMysql(mysqlString)
        return format(d, DateUtil.READABLE_TIME_FORMAT, {locale: nl})
    }

    static getAanmaakEnWijzigingString = (provider) => {
        const ad = DateUtil.getReadableDateString(provider.datum_aanmaak)
        const wd = DateUtil.getReadableDateString(provider.datum_aanmaak)
        const wu = DateUtil.getReadableTimeString(provider.datum_aanmaak)
        return `Aangemaakt op ${ad} | Laatst gewijzigd op ${wd} om ${wu}u`
    }

    static getNowTimeObject = () => {
        return {
            hour: format(roundToNearestMinutes(new Date(), { nearestTo: 5 }), 'HH'),
            minute: format(roundToNearestMinutes(new Date(), { nearestTo: 5 }), 'mm')
        }
    }

    static calculateTimesheetDuration = (timesheet, returnMilliseconds: boolean = false) => {
        const from = DateUtil.dateFromMysql(timesheet.clock_in)
        const to = DateUtil.dateFromMysql(timesheet.clock_out)
        const milliseconds = to.getTime() - from.getTime()
        const hours = milliseconds/1000/60/60.0
        if (returnMilliseconds) return milliseconds
        return hours.toFixed(2)
    }
}
